import React from 'react';
import './MarriottDigitalHero.css';
import OptimizedImage from './OptimizedImage';

import beachHero from 'url:../../assets-optimized/redesign/solutions/on_site_travel_hero.png';
import beachHeroavif from 'url:../../assets-optimized/redesign/solutions/on_site_travel_hero.avif';
import beachHerowebp from 'url:../../assets-optimized/redesign/solutions/on_site_travel_hero.webp';
import beachHeroMobile from 'url:../../assets-optimized/redesign/solutions/on_site_travel_hero_mobile.png';
import beachHeroMobileavif from 'url:../../assets-optimized/redesign/solutions/on_site_travel_hero_mobile.avif';
import beachHeroMobilewebp from 'url:../../assets-optimized/redesign/solutions/on_site_travel_hero_mobile.webp';

const MarriottDigitalHero = () => {
  return (
    <section className='marriott-digital-hero'>
      <div className='md-hero-left'>
        <OptimizedImage
          avif={beachHeroavif}
          webp={beachHerowebp}
          fallback={beachHero}
          mobileAvif={beachHeroMobileavif}
          mobileWebp={beachHeroMobilewebp}
          mobileFallback={beachHeroMobile}
          alt='Traveler on a beach using a laptop'
          className='md-hero-image'
        />
        <div className='md-hero-left-overlay'>
          <h2 className='md-hero-pill'>
            <span className='no-wrap'>On-Site Travel</span> <br />
            Platform
          </h2>
        </div>
      </div>
      <div className='md-hero-right'>
        <h1 className='md-hero-right-title'>
          WEB, APP, <br className='desktop-only' />
          EMAIL
        </h1>
        <p className='md-hero-right-statement'>
          <span className='md-hero-bullet' aria-hidden='true' />
          WHERE INTENT BUILDS, AND CHOICES ARE MADE.
        </p>
      </div>
    </section>
  );
};

export default MarriottDigitalHero;
